import billingModule from '../../billing.module';
import template from './billingModalMakePayment.component.html';
import style from './billingModalMakePayment.component.scss';

export default billingModule.component('billingModalMakePayment', {
    template,
    style,
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: '<',
        test: '<'
    },
    controller: function(
        billingPaymentService,
        billingAccountService,
        $state,
        stateConstants,
        asNotifier,
        textResources,
        $q,
        $filter,
        collectionHelper,
        $rootScope,
        billingOverviewEventConstants
    ) {
        let vm = this;
        const currentBalanceId = 0;
        const invoiceValueDeliminator = '|';

        vm.invoiceInput = {
            placeholder:
                textResources.billingMakePaymentSelectYourInvoicesPlaceholder,
            options: {
                maxSelection: 0,
                dropupAuto: false,
                container: 'body',
                selectedTextFormat: 'static'
            },
            validation: {
                required: true
            },
            items: []
        };

        vm.selectedInvoicesModel = [];

        vm.$onInit = () => {
            vm.currencyLabelText = vm.resolve.account.currency + ' ';

            const currentBalanceLabel = textResources.billingMakePaymentCurrentBalanceItemLabel.replace(
                '{formattedBalance}',
                $filter('currency')(
                    vm.resolve.account.balance,
                    vm.currencyLabelText
                )
            );
            vm.isAgreeToTermsAndConditions = false;
            vm.currentBalanceInvoiceItem = {
                value: serializeInvoiceSelectionValue(
                    currentBalanceId.toString(),
                    vm.resolve.account.balance,
                    currentBalanceLabel
                ),
                label: currentBalanceLabel
            };

            initCustomerAgreement(vm.resolve.customerAgreementResult);
            initInvoices(vm.resolve.invoiceResult.items);
            vm.isAutoPayEnabled = vm.resolve.billingActionResult;
            vm.isAutoPayVisible = vm.resolve.billingActionResult;
        };

        vm.submitPayment = () => {
            vm.isCreatingPayment = true;

            const result = submitPayment();

            result
                .then(
                    () => {
                        vm.close();

                        $rootScope.$broadcast(
                            billingOverviewEventConstants.makePaymentSuccess
                        );

                        $state.transitionTo(
                            stateConstants.billing.overview.name,
                            null,
                            {
                                reload: true
                            }
                        );
                    },
                    () => {
                        asNotifier.error(
                            `${textResources.genericError} ${
                                textResources.ifProblemPersists
                            }`
                        );
                    }
                )
                .finally(() => {
                    vm.isCreatingPayment = false;
                });
        };

        vm.disableSubmitPayment = () => {
            return (
                vm.isCreatingPayment ||
                !vm.isAgreeToTermsAndConditions ||
                !collectionHelper.any(vm.selectedInvoicesModel)
            );
        };

        vm.onSelectedInvoicesChange = invoiceValues => {
            updateSelectedInvoices(invoiceValues);
        };

        function invalidateDropdownText() {
            const one = 1;

            if (vm.selectedInvoicesModel.length > one) {
                const totalAmount = getTotalSelectedAmount();

                vm.invoiceInput.placeholder = textResources.billingMakePaymentMultiSelectPlaceholder
                    .replace(
                        '{totalItems}',
                        vm.selectedInvoicesModel.length.toString()
                    )
                    .replace(
                        '{amount}',
                        $filter('currency')(totalAmount, vm.currencyLabelText)
                    );

                return;
            }

            if (vm.selectedInvoicesModel.length === one) {
                const firstSelectedItem = collectionHelper.first(
                    vm.selectedInvoicesModel
                );

                if (firstSelectedItem === vm.currentBalanceInvoiceItem.value) {
                    vm.invoiceInput.placeholder =
                        vm.currentBalanceInvoiceItem.label;

                    return;
                } else {
                    vm.invoiceInput.placeholder = deserializeInvoiceSelectionValue(
                        firstSelectedItem
                    ).label;

                    return;
                }
            }

            if (!collectionHelper.any(vm.selectedInvoicesModel)) {
                vm.invoiceInput.placeholder =
                    textResources.billingMakePaymentSelectYourInvoicesPlaceholder;
            }
        }

        function getTotalSelectedAmount() {
            let totalAmount = 0;

            vm.selectedInvoicesModel.forEach(invoice => {
                totalAmount += parseFloat(
                    deserializeInvoiceSelectionValue(invoice).value
                );
            });

            return totalAmount;
        }

        function submitPayment() {
            const deferred = $q.defer();
            const paymentDetail = getPaymentDetail();

            billingPaymentService.createPayment(paymentDetail).then(
                () => {
                    if (vm.isAutoPayEnabled && vm.isAutoPayVisible) {
                        const account = {
                            autoPay: vm.isAutoPayEnabled
                        };

                        billingAccountService
                            .updateBillingAccount(account)
                            .then(
                                () => deferred.resolve(),
                                () => deferred.reject()
                            );
                    } else {
                        deferred.resolve();
                    }
                },
                () => deferred.reject()
            );

            return deferred.promise;
        }

        function initInvoices(payableInvoices) {
            const groupText = textResources.billingMakePaymentGroupingText;

            vm.invoiceInput.items = [vm.currentBalanceInvoiceItem].concat(
                payableInvoices.map(payable => {
                    return {
                        value: serializeInvoiceSelectionValue(
                            payable.id,
                            payable.amount,
                            payable.label
                        ),
                        amount: payable.amount,
                        label: payable.label,
                        optgroup: groupText
                    };
                })
            );

            updateSelectedInvoices([vm.currentBalanceInvoiceItem.value]);
        }

        function initCustomerAgreement(configValue) {
            vm.appspaceURLCustomerAgreement =
                configValue.appspaceURLCustomerAgreement;
        }

        function serializeInvoiceSelectionValue(id, amount, label) {
            return (
                id +
                invoiceValueDeliminator +
                amount +
                invoiceValueDeliminator +
                label
            );
        }

        function deserializeInvoiceSelectionValue(value) {
            const splitValue = value.split(invoiceValueDeliminator);
            const idIndex = 0;
            const valueIndex = 1;
            const labelIndex = 2;

            return {
                id: splitValue[idIndex],
                value: splitValue[valueIndex],
                label: splitValue[labelIndex]
            };
        }

        function getPaymentDetail() {
            const invoiceValues =
                collectionHelper.first(vm.selectedInvoicesModel) ===
                vm.currentBalanceInvoiceItem.value
                    ? vm.invoiceInput.items
                    : vm.invoiceInput.items.filter(x =>
                          collectionHelper.any(
                              vm.selectedInvoicesModel.filter(
                                  y => y === x.value
                              )
                          )
                      );
            const payables = invoiceValues
                .filter(x => x.value !== vm.currentBalanceInvoiceItem.value)
                .map(x => {
                    const deserializedValue = deserializeInvoiceSelectionValue(
                        x.value
                    );
                    return {
                        id: deserializedValue.id,
                        amount: parseFloat(deserializedValue.value)
                    };
                });
            let totalAmount = 0;

            payables.forEach(x => {
                totalAmount += x.amount;
            });

            return {
                amount: totalAmount,
                payables: payables
            };
        }

        function updateSelectedInvoices(invoices) {
            const firstIndex = 0;
            const secondIndex = 1;
            const currentSelectionWithoutCurrentBalance = collectionHelper.any(
                vm.selectedInvoicesModel.filter(
                    x => x === vm.currentBalanceInvoiceItem.value
                )
            );
            const latestSelectionWithCurrentBalance =
                collectionHelper.first(invoices) ===
                vm.currentBalanceInvoiceItem.value;

            if (
                currentSelectionWithoutCurrentBalance &&
                latestSelectionWithCurrentBalance
            ) {
                vm.selectedInvoicesModel = invoices.slice(secondIndex);
            } else if (
                !currentSelectionWithoutCurrentBalance &&
                latestSelectionWithCurrentBalance
            ) {
                vm.selectedInvoicesModel = invoices.slice(
                    firstIndex,
                    secondIndex
                );
            } else {
                vm.selectedInvoicesModel = invoices;
            }

            invalidateDropdownText();
        }
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-modal-make-payment/billingModalMakePayment.component.js